import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FileUpload from "./FileUpload";
import { ItemContext } from "../../Context/ItemContext";
import { useHistory, Link } from "react-router-dom"; // Add Link

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createItem, updateItem } from "../../actions/itemActions";
import { useSnackbar } from "react-simple-snackbar";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { StockContext } from "../../Context/StockContext";
import { getAllUnits } from "../../actions/unitActions";
import {
  createCategory,
  getAllCategories,
  deleteCategory,
} from "../../actions/categoryActions";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Container,
  FormControlLabel,
  Switch,
  FormGroup,
  Radio,
  FormHelperText,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
  inputStyle: {
    width: "100%",
    fontFamily: "kruti-101",
  },
  formControl: {
    width: "100%",
  },
  container: {
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px",
  },
  radioLabel: {
    // margin: theme.spacing(1, 0),
    display: "block",
  },
  input: {
    display: "none",
  },
  disabledMenuItem: {
    color: theme.palette.text.disabled, // Greyed out style for inactive categories
  },
}));

const DialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = (props) => {
  const classes = useStyles();
  return <MuiDialogContent {...props} />;
};

const DialogActions = (props) => {
  const classes = useStyles();
  return <MuiDialogActions {...props} />;
};
// const units = [
//   {
//     id: "661a1f3b4b3f5a001f3e1001",
//     name: "Kilogram",
//     abbreviation: "kg",
//     baseUnit: null,
//     conversionFactor: 1,
//     type: ["STOCK", "SALE", "PURCHASE", "ADJUSTMENT"],
//   },
//   {
//     id: "661a1f3b4b3f5a001f3e1002",
//     name: "Gram",
//     abbreviation: "g",
//     baseUnit: "661a1f3b4b3f5a001f3e1001", // Reference to Kilogram
//     conversionFactor: 0.001,
//     type: ["STOCK", "SALE", "PURCHASE"],
//   },
//   {
//     id: "661a1f3b4b3f5a001f3e1003",
//     name: "Liter",
//     abbreviation: "L",
//     baseUnit: null,
//     conversionFactor: 1,
//     type: ["STOCK", "SALE", "PURCHASE", "ADJUSTMENT"],
//   },
//   {
//     id: "661a1f3b4b3f5a001f3e1004",
//     name: "Milliliter",
//     abbreviation: "mL",
//     baseUnit: "661a1f3b4b3f5a001f3e1003", // Reference to Liter
//     conversionFactor: 0.001,
//     type: ["STOCK", "SALE", "PURCHASE"],
//   },
// ];

const AddItem = ({ setOpen, open }) => {
  const classes = useStyles();
  const history = useHistory();

  const location = useLocation();
  const profileDetail = JSON.parse(localStorage.getItem("profileDetail"));
  const profile = JSON.parse(localStorage.getItem("profile"));
  const units = useSelector((state) => state.units.units);
  // console.log(units);
  const [itemData, setItemData] = useState({
    itemName: "",
    category: {
      categoryName: "",
      categoryId: null,
    },
    units: {
      sale: {
        unit: null,
        price: "",
      },
      purchase: {
        unit: null,
        cost: "",
      },
      stock: {
        unit: null,
        quantity: 0,
      },
    },
    barcode: "",
    img: null,
    toggleStock: false,
    isStaffReq: false,
    stockQty: {
      initialQty: 0,
      currentQty: 0,
      minQty: 0,
      maxQty: 0,
    },
    vat: profile?.userProfile?.commonVatRate || "",
  });
  // const [itemData, setItemData] = useState({
  //   itemName: "",
  //   category: {
  //     categoryName: "",
  //     categoryId: "",
  //   },
  //   unitPrice: "",
  //   costPrice: "",
  //   barcode: "",
  //   unit: "",
  //   itemId: [],
  //   img: null,
  //   toggleStock: false,
  //   isStaffReq: false,
  //   stockQty: {
  //     initialQty: 0,
  //     currentQty: 0,
  //     minQty: 0,
  //     maxQty: 0,
  //   },

  // });
  const { itemId, setItemId } = useContext(ItemContext);
  const dispatch = useDispatch();
  const item = useSelector((state) =>
    itemId ? state.items.items.find((i) => i.id === itemId) : null
  );
  // console.log("Edit item", item);
  const { categories } = useSelector((state) => state.categories);

  const [isEditMode, setIsEditMode] = useState(false); // New state variable
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [errors, setErrors] = useState({});
  const { stock, trackStock, setTrackStock } = useContext(StockContext);
  // const [option, setOption] = useState("manualAdd"); // Default to fileUpload for new items
  const handleTrackStockChange = (event) => {
    setTrackStock(event.target.checked);
    setItemData({
      ...itemData,
      toggleStock: event.target.checked,
    });
  };

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 200, // Adjust this value as needed
        overflowY: "auto", // Enables vertical scrolling
      },
    },
  };

  const handleIsStaffRequiredChange = (event) => {
    // setTrackStock(event.target.checked);
    setItemData({
      ...itemData,
      isStaffReq: event.target.checked,
    });
  };
  useEffect(() => {
    if (!units.length) {
      dispatch(getAllUnits());
    }

    // dispatch(getItemsByUser({ search: user.result?.id || user.result.googleId }));
  }, [dispatch]);
  useEffect(() => {
    if (!categories.length) {
      dispatch(getAllCategories());
    }
  }, [dispatch, categories]);

  // useEffect(() => {
  //   if (itemId) {
  //     setOption("manualAdd");
  //   }
  //   // else {
  //   //   setOption("fileUpload");
  //   // }
  // }, [itemId]);

  // const handleSubmitItem = (e) => {
  //   e.preventDefault();
  //   if (validateForm()) {
  //     if (itemId) {
  //       dispatch(updateItem(itemId, itemData, openSnackbar));
  //       window.location.reload();
  //     } else {
  //       const updatedItemData = { ...itemData };
  //       // console.log(updatedItemData)

  //       updatedItemData.vat = profile?.userProfile?.commonVatRate;
  //       updatedItemData.stockQty.initialQty =
  //         updatedItemData.units?.stock?.quantity;
  //       updatedItemData.stockQty.currentQty =
  //         updatedItemData.units?.stock?.quantity;
  //       setItemData(updatedItemData);
  //       dispatch(createItem(updatedItemData, openSnackbar));
  //       console.log(updatedItemData)

  //       window.location.reload();
  //     }
  //     clear();
  //     handleClose();
  //   }
  // };

  

  const handleSubmitItem = (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (itemId) {
        dispatch(updateItem(itemId, itemData, openSnackbar));
        window.location.reload();
      } else {
        const updatedItemData = { ...itemData };
        updatedItemData.vat = profile?.userProfile?.commonVatRate || 0;
        // updatedItemData.stockQty.initialQty = parseFloat(
        //   updatedItemData.units?.stock?.quantity || 0
        // );
        // updatedItemData.stockQty.currentQty = parseFloat(
        //   updatedItemData.units?.stock?.quantity || 0
        // );
        // updatedItemData.units.stock.quantity = parseFloat(
        //   updatedItemData.units?.stock?.quantity || 0
        // );
        console.log("Dispatching createItem with:", updatedItemData);
        dispatch(createItem(updatedItemData, openSnackbar))
          .then(() => {
            window.location.reload(); // Reload only after item creation succeeds
          })
          .catch((error) => {
            console.error("Failed to create item or stock:", error);
          });
      }
      clear();
      handleClose();
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (!name) return;

    setItemData((prevItemData) => {
      const keys = name.split(".");
      const updatedData = { ...prevItemData };
      let currentLevel = updatedData;

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        }
        currentLevel = currentLevel[key];
      }

      // Handle dropdowns explicitly
      if (name.includes("unit")) {
        currentLevel[keys[keys.length - 1]] = value; // Assign the id directly
      } else {
        currentLevel[keys[keys.length - 1]] = value;
      }

      return updatedData;
    });
  };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;

  //   if (!name) return; // Ensure the input has a name

  //   setItemData((prevItemData) => {
  //     // Split the name into keys for nested updates
  //     const keys = name.split(".");

  //     // Create a deep copy of the existing data
  //     const updatedData = { ...prevItemData };

  //     // Recursively traverse and set the value at the appropriate depth
  //     let currentLevel = updatedData;
  //     for (let i = 0; i < keys.length - 1; i++) {
  //       const key = keys[i];

  //       // Ensure the object exists at each level
  //       if (!currentLevel[key]) {
  //         currentLevel[key] = {};
  //       }
  //       currentLevel = currentLevel[key];
  //     }

  //     // Set the value at the last level
  //     currentLevel[keys[keys.length - 1]] = value;

  //     return updatedData;
  //   });
  // };

  // function handleFileChange(event) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onload = (e) => {
  //       const base64ImageData = e.target.result;
  //       setItemData({ ...itemData, img: base64ImageData });
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const url = "https://api.cloudinary.com/v1_1/almpo/image/upload"; // Replace 'almpo' with your Cloudinary cloud name
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "invoice"); // Replace with your upload preset

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      const data = await response.json();
      setItemData({ ...itemData, img: data.secure_url }); // Store Cloudinary URL
    } catch (error) {
      console.error("Error uploading to Cloudinary:", error);
    }
  };

  // const handleOptionChange = (selectedOption) => {
  //   setOption(selectedOption);
  //   // if (selectedOption === "fileUpload" && !itemId) {
  //   //   history.push("/bulk-upload"); // Redirect to bulk upload page
  //   //   handleClose(); // Close the dialog
  //   // }
  // };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    ;
    if (itemData.itemName.trim() === "") {
      newErrors.itemName = "Item name is required";
      isValid = false;
    }
    if (!itemData.units?.sale?.price) {
      newErrors.salesPrice = "Sales price is required";
      isValid = false;
    }

    // if (!itemData.units?.purchase?.cost) {
    //   newErrors.costPrice = "Purchase cost is required";
    //   isValid = false;
    // }

    // if (itemData.units?.sale?.unit?.id.trim() === "") {
    //   newErrors.saleUnit = "Sales unit is required";
    //   isValid = false;
    // }
    // if (itemData.units?.stock?.unit?.id.trim() === "") {
    //   newErrors.saleUnit = "Stock unit is required";
    //   isValid = false;
    // }
    // if (!itemData.units?.stock?.quantity) {
    //   newErrors.stockUnit = "Stock unit is required";
    //   isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };

  const clear = () => {
    setItemData({
      itemName: "",
      category: "",
      unitPrice: "",
      unit: "",
      itemId: [],
      img: null,
      stockQty: null,
      vat: "",
    });
    setErrors({});
    setTrackStock(false);
  };

  useEffect(() => {
    if (item) {
      setItemData({
        ...item,
        units: {
          sale: {
            unit: item.units?.sale?.unit?.id || null, // Store only the ID
            price: item.units?.sale?.price || "",
          },
          purchase: {
            unit: item.units?.purchase?.unit?.id || null, // Store only the ID
            cost: item.units?.purchase?.cost || "",
          },
          stock: {
            unit: item.units?.stock?.unit?.id || null, // Store only the ID
            quantity: item.units?.stock?.quantity || 0,
          },
        },
        category: {
          categoryName: item.category?.categoryName || "",
          categoryId: item.category?.categoryId || null,
        },
      });
      setIsEditMode(true);
    } else {
      // When opening for a new item, reset the form and switch to add mode
      clear();
      setIsEditMode(false);
    }
  }, [item, open]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  // useEffect(() => {
  //   var checkId = user?.result?.id;
  //   if (checkId !== undefined) {
  //     setItemData({ ...itemData, itemId: [checkId] });
  //   } else {
  //     setItemData({ ...itemData, itemId: [user?.result?.googleId] });
  //   }
  // }, [location]);

  const handleClose = () => {
    setItemData({
      itemName: "",
      category: "",
      unitPrice: "",
      costPrice: "",
      unit: "",
      itemId: [],
      img: null,
      vat: "",
    });
    setErrors({});
    setOpen(false);
  };
  // const handleOptionChange = (selectedOption) => {
  //   setOption(selectedOption);
  // };
  return (
    <div>
      <Dialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        // fullWidth
        maxWidth="md" // You can adjust this to control the width (e.g., 'sm', 'md', 'lg')
        PaperProps={{
          style: {
            position: "absolute",
            top: "38%",
            left: "50%",
            transform: "translate(-50%, -50%)", // Centers the dialog
            width: "auto", // Adjust width as needed
            maxHeight: "88vh", // Optional: Limits height to avoid overflow
            overflowY: "auto", // Optional: Adds scroll if content overflows
          },
        }}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          style={{
            paddingLeft: "20px",
            color: "white",
            backgroundColor: "#ef7f1a",
          }}
        >
          {itemId ? "Edit Item" : "New Item"}
        </DialogTitle>
        <DialogContent dividers>
          {/* {!itemId && (
            <FormGroup row >
              <FormControlLabel
                className={classes.radioLabel}
                control={
                  <Radio
                    checked={option === "manualAdd"}
                    onChange={() => handleOptionChange("manualAdd")}
                    value="manualAdd"
                    color="primary"
                  />
                }
                label="Manually Add Item"
              />

              <FormControlLabel
                control={
                  <Radio
                    checked={option === "fileUpload"}
                    onChange={() => handleOptionChange("fileUpload")}
                    value="fileUpload"
                    color="primary"
                  />
                }
                label="Bulk Upload via File"
              />
            </FormGroup>
          )} */}
          {/* {option === "fileUpload" && (
            <FileUpload setOpen={setOpen} open={open}  />
          )} */}
          {/* {option === "fileUpload" && (
            <Link to="/bulk-upload" style={{ marginLeft: 16 }}>
              <Button variant="outlined" color="primary"  onClick={() => (window.location.href = "/bulk-upload")}>
                Bulk Upload Items
              </Button>
            </Link>
          )} */}

          <div>
            <Container className={classes.container}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    className={classes.inputStyle}
                    name="itemName"
                    type="text"
                    required
                    onChange={handleChange}
                    value={itemData.itemName}
                    error={!!errors.itemName} // Check if error exists
                    helperText={errors.itemName} // Display error message
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Category
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={
                          itemData.category ? itemData.category.categoryId : ""
                        }
                        onChange={(e) => {
                          const selectedCategoryId = e.target.value;
                          const selectedCategory = categories.find(
                            (category) => category.id === selectedCategoryId
                          );

                          setItemData({
                            ...itemData,
                            category: {
                              categoryName: selectedCategory
                                ? selectedCategory?.categoryName
                                : "",
                              categoryId: selectedCategoryId,
                            },
                          });
                        }}
                        label="Category"
                      >
                        {categories.map((category, index) => (
                          <MenuItem key={index} value={category.id}>
                            {category.categoryName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}
                <Grid item xs={12} sm={6}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="category-label">Category</InputLabel>
                    <Select
                      labelId="category-label"
                      id="category-select"
                      value={itemData?.category?.categoryId || ""}
                      onChange={(e) => {
                        const selectedCategoryId = e.target.value;
                        const selectedCategory = categories.find(
                          (category) => category.id === selectedCategoryId
                        );
                        setItemData({
                          ...itemData,
                          category: {
                            categoryName: selectedCategory?.categoryName || "",
                            categoryId: selectedCategoryId,
                          },
                        });
                      }}
                      label="Category"
                      MenuProps={menuProps}
                    >
                      {categories.map((category) => (
                        // <MenuItem key={category.id} value={category.id}>
                        //   {category.categoryName}
                        // </MenuItem>

                        <MenuItem
                          key={category.id}
                          value={category.id}
                          disabled={!category.isActive} // Disable if inactive
                          className={
                            !category.isActive ? classes.disabledMenuItem : ""
                          }
                        >
                          {category.isActive
                            ? category.categoryName
                            : `${category.categoryName} (INACTIVE)`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                    <TextField
                      label="Sales Rate"
                      variant="outlined"
                      className={classes.inputStyle}
                      name="unitPrice"
                      type="text"
                      required
                      onChange={handleChange}
                      value={itemData.unitPrice}
                      error={!!errors.unitPrice} // Check if error exists
                      helperText={errors.unitPrice} // Display error message
                    />
                  </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                    <TextField
                      label="Purchase Rate"
                      variant="outlined"
                      className={classes.inputStyle}
                      name="costPrice"
                      type="number"
                      onChange={handleChange}
                      value={itemData.costPrice}
                      error={!!errors.costPrice} // Check if error exists
                      helperText={errors.costPrice} // Display error message
                    />
                  </Grid> */}

                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={!!errors.saleUnit}
                  >
                    <InputLabel id="sales-unit-label">Sales Unit</InputLabel>
                    <Select
                      labelId="sales-unit-label" // Link the InputLabel to the Select
                      id="sales-unit-select" // Optional but recommended for accessibility
                      name="units.sale.unit"
                      value={itemData?.units?.sale?.unit || ""}
                      onChange={handleChange}
                      label="Sales Unit" // Ensure the label prop matches the InputLabel text
                      MenuProps={menuProps}
                    >
                      {units.map((unit) => (
                        <MenuItem key={unit.id} value={unit.id}>
                          {unit.name} ({unit.abbreviation})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Sales Price"
                    name="units.sale.price"
                    variant="outlined"
                    type="number"
                    value={itemData?.units?.sale?.price}
                    onChange={handleChange}
                    error={!!errors.salesPrice}
                    helperText={errors.salesPrice}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="purchase-unit-label">
                      Purchase Unit
                    </InputLabel>
                    <Select
                      labelId="purchase-unit-label" // Link the InputLabel to the Select
                      id="purchase-unit-select" // Optional but recommended for accessibility
                      name="units.purchase.unit"
                      MenuProps={menuProps}
                      value={itemData?.units?.purchase?.unit || ""}
                      onChange={handleChange}
                      label="Purchase Unit" // Ensure the label prop matches the InputLabel text
                    >
                      {units.map((unit) => (
                        <MenuItem key={unit.id} value={unit.id}>
                          {unit.name} ({unit.abbreviation})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Opening Purchase Cost"
                    name="units.purchase.cost"
                    type="number"
                    variant="outlined"
                    value={itemData?.units?.purchase?.cost}
                    onChange={handleChange}
                    error={!!errors.costPrice}
                    helperText={errors.costPrice}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Barcode"
                    variant="outlined"
                    className={classes.inputStyle}
                    name="barcode"
                    type="number"
                    onChange={handleChange}
                    value={itemData.barcode}
                    error={!!errors.barcode} // Check if error exists
                    helperText={errors.barcode} // Display error message
                  />
                </Grid>

                {(profileDetail?.vatOptions === "itemBased" ||
                  profile.userProfile.vatOptions === "itemBased") &&
                  (!profileDetail || profileDetail.vatType !== "common") && (
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Vat"
                        variant="outlined"
                        className={classes.inputStyle}
                        name="vat"
                        type="number"
                        onChange={handleChange}
                        value={itemData.vat}
                        error={!!errors.vat} // Check if error exists
                        helperText={errors.vat} // Display error message
                      />
                    </Grid>
                  )}

                <Grid item xs={12} sm={6}>
                  {!itemData.img && (
                    <>
                      <input
                        accept="image/*"
                        className={classes.input}
                        onChange={handleFileChange}
                        id="icon-button-file"
                        type="file"
                      />
                      <label htmlFor="icon-button-file">
                        <IconButton
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                        >
                          <PhotoCamera />
                        </IconButton>
                      </label>
                    </>
                    // <input
                    //   name="image"
                    //   type="file"

                    //   value=""
                    // />
                  )}
                  {itemData.img && (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginTop: "10px" }}>Selected Image: </p>
                      <img
                        src={itemData.img}
                        alt="Image"
                        style={{ width: "50px" }}
                      />
                      <IconButton
                        onClick={() =>
                          setItemData((prevData) => ({
                            ...prevData,
                            img: null,
                          }))
                        }
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  )}
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      label="Is Staff Required?"
                      control={
                        <Switch
                          checked={itemData?.isStaffReq}
                          onChange={handleIsStaffRequiredChange}
                          name="isStaffReq"
                          color="primary"
                        />
                      }
                    />
                  </Grid> */}
              </Grid>
            </Container>
            {itemData.category.categoryName != "Services" && (
              <Container
                className={classes.container}
                style={{ marginTop: "5px" }}
              >
                <FormControlLabel
                  label="Track Stock"
                  control={
                    <Switch
                      checked={
                        itemData?.toggleStock
                          ? itemData.toggleStock
                          : trackStock
                      }
                      onChange={handleTrackStockChange}
                      name="trackStock"
                      color="primary"
                    />
                  }
                />
                {itemData.toggleStock && (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="stock-unit-label">
                            Stock Unit
                          </InputLabel>
                          <Select
                            labelId="stock-unit-label" // Link the InputLabel to the Select
                            id="stock-unit-select" // Optional but recommended for accessibility
                            name="units.stock.unit"
                            value={itemData?.units?.stock?.unit || ""}
                            onChange={handleChange}
                            MenuProps={menuProps}
                            label="Stock Unit" // Ensure the label prop matches the InputLabel text
                          >
                            {units.map((unit) => (
                              <MenuItem key={unit.id} value={unit.id}>
                                {unit.name} ({unit.abbreviation})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Stock Quantity"
                          name="units.stock.quantity"
                          type="number"
                          variant="outlined"
                          value={itemData?.units?.stock?.quantity}
                          onChange={handleChange}
                          error={!!errors.stockUnit}
                          helperText={errors.stockUnit}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Max Qty"
                          variant="outlined"
                          className={classes.inputStyle}
                          name="stockQty.maxQty"
                          type="number"
                          onChange={handleChange}
                          value={itemData?.stockQty?.maxQty}
                          error={!!errors?.stockQty?.maxQty} // Check if error exists
                          helperText={errors?.stockQty?.maxQty}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Min Qty"
                          variant="outlined"
                          className={classes.inputStyle}
                          name="stockQty.minQty"
                          type="number"
                          onChange={handleChange}
                          value={itemData?.stockQty?.minQty}
                          error={!!errors?.stockQty?.minQty} // Check if error exists
                          helperText={errors?.stockQty?.minQty}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Container>
            )}
            <Container style={{ margin: "10px" }}>
              <Button
                autoFocus
                onClick={handleSubmitItem}
                variant="contained"
                style={{
                  backgroundColor: "#ef7f1a",
                  color: "white",
                }}
              >
                Save Item
              </Button>
            </Container>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddItem;
